<form [formGroup]="complementoForm">
<h5>Detalhes da Liquidação</h5>
  <hr />
  <div class="form-group">
    <label>Forma de Recebimento</label>
    <input type="text" class="form-control" readonly="true" id="formaRecebimento" formControlName="formaRecebimento" />
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>Tipo Conta do Credor</label>
      <input id="tipoContaCredor" type="text" class="form-control" readonly="true" formControlName="tipoContaCredor"/>
    </div>
    <div class="form-group col-md-8">
      <label>Banco do Credor</label>
      <input type="text" class="form-control" readonly="true" id="bancoCredor" formControlName="bancoCredor" />
    </div>
    <div class="form-group col-md-4">
      <label>Agência do Credor</label>
      <input type="text" class="form-control" readonly="true" id="agenciaCredor" formControlName="agenciaCredor" />
    </div>
    <div class="form-group col-md-8">
      <label>Conta do Credor</label>
      <input type="text" class="form-control" readonly="true" id="contaCredor" formControlName="contaCredor" />
    </div>
  </div>

  <div class="fieldRow"></div>
<ng-container *ngIf="consignatarias?.length > 0;">
  <div class="row">
    <div class="form-group col-md-12">
      <h5>Detalhes da Consignação</h5>
    </div>
  </div>

  <div class="row">
<div class="form-group col-md-12">
    <aslib-grid  
    #grid id="grid" name="grid" 
    headerTitle="Detalhes Consignatária" 
    [(dataset)]="consignatarias"
    [selectOnRowClick]="false" [pagination]="false" [regPerPageVisible]="false">  
    >

      <aslib-grid-column [property]="'id'" [visible]="false" 
      header="id" class="text-right" [width]="1" 
      [sortable]="true" [resizable]="true">
      </aslib-grid-column>
    
      <aslib-grid-column [property]="'codigoCredor'" 
      header="Código do Credor" class="text-left" [width]="100"
      [sortable]="false" [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.codigoCredor | credor}}</span>
      </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'nomeTipo'" 
      header="Nome"  class="text-left" [width]="120"
      [sortable]="false"  [resizable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.nomeTipo}}</span>
      </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'nomeFormaRecebimento'" 
      header="Forma de Recebimento" class="text-left"  [width]="100"
      [sortable]="false"  [resizable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{item.nomeFormaRecebimento}}</span>
        </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'valor'" 
      header="Valor Retido" class="text-left" [width]="120" 
      [sortable]="false"  [resizable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{item.valor | currency:'BRL'}}</span>
        </ng-template>
      </aslib-grid-column>

    </aslib-grid>
</div>
  </div>
  </ng-container>

  <div class="fieldRow"></div>
  
  <div class="row">
    <div class="form-group col-md-12">
      <h5>Detalhes de Subelemento</h5>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-8">
      <label>Subelemento</label>
      <input type="text" class="form-control" readonly="true" id="subelemento" formControlName="subelemento" />
    </div>
    <div class="form-group col-md-4">
      <label>Valor por Subelemento</label>
      <input id="valorSubelemento"  type="text" class="form-control" formControlName="valorSubelemento" 
          currencyMask [options]="{ precision: 2, prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false, allowZero: true}"/>
    </div>
  </div>
  <hr />
  <div class="form-group row pull-right">
    <div class="controls mr-2 col-md-12">
      <button class="btn btn-primary" type="button" (click)="cancelarOnClick()">Fechar</button>
    </div>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-complemento/liq-complemento.component.html